import 'devextreme/dist/css/dx.common.css';
import "devexpress-gantt/dist/dx-gantt.min.css";
import './themes/generated/theme.base.css';
import './themes/generated/theme.additional.css';
import './themes/fontawesome-free-6.1.0-web/css/all.css';
import "./devextreme-license";
import { createApp } from 'vue';

import App from './App.vue';
import { router, appInfo } from "./scripts/helpers";
import { store } from "./scripts/store";
import { detectLanguage, applyLanguageToTranslationTree } from "./scripts/helpers/language";
import * as translations from "./scripts/translation";

window.___GOP = {};
window.___GOP.dataModified = false;

window.___GOP.VueClientDateTimeStamp = "2026_09_01_09_16";

//window.___GOP.ElementHelps = null;
//window.___GOP.ApiPrefix = '';
window.___GOP.ApiPrefix = 'api';

window.___GOP.Language = detectLanguage();

//Resolve all bilingual (en/cs) translation trees to the detected language before the app is used.
//Every exported translation object (UITR, and all generated *TR.js dataset-column translations)
//is walked and mutated in place so existing code using `.tr` / `.trL` keeps working unchanged.
Object.keys(translations).forEach(key => applyLanguageToTranslationTree(translations[key], window.___GOP.Language));

const app = createApp(App);

app.use(store);
app.use(router);

app.config.globalProperties.$appInfo = appInfo;

app.mount("#app");

window.onbeforeunload = (e) => {
    if (window.___GOP && window.___GOP.dataModified === true)
        return "dataModified";
};